var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reload-div"},[_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getAll}},[_vm._v("重新加载")])],1),_c('div',{staticClass:"left-data"},[_vm._v(" "+_vm._s(_vm.next.id)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }